import { Check, LoaderCircle } from "lucide-react";
import { t } from "../i18n";

export function SaveStatus({
  status,
}: {
  status?: "saving" | "saved" | "error";
}) {
  return (
    <span
      className={`flex items-center gap-1 text-[11px] ${status === "error" ? "text-red-600" : "text-stone-400"}`}
    >
      {status === "saving" ? (
        <>
          <LoaderCircle className="animate-spin" size={12} /> {t("Saving…")}
        </>
      ) : status === "saved" ? (
        <>
          <Check size={12} /> {t("Saved")}
        </>
      ) : status === "error" ? (
        "Save failed"
      ) : (
        "Saved automatically"
      )}
    </span>
  );
}
